<footer>
  <div class="footer-container">
    <div class="footer-logo">
      <img src="assets/cosybio-logo.png" alt="Logo">
    </div>
    <div class="footer-links">
      <a routerLink="/cookie">Cookie Policy</a>
      <a routerLink="/privacy">Privacy Policy</a>
      <a routerLink="/tos">Terms of Service</a>
      <a href="https://www.cosy.bio/contact">Imprint</a>
    </div>
    <div class="footer-social">
      <a href="https://x.com/cosybio_UHH" target="_blank">
        <img src="assets/twitter-icon.png" alt="x/Twitter">
      </a>
      <a href="https://de.linkedin.com/company/cosy-bio" target="_blank">
        <img src="assets/linkedin-icon.png" alt="LinkedIn">
      </a>
    </div>
    <div class="footer-copy">
      <p>&copy; 2025 Institute for Computational Systems Biology - University of Hamburg. All rights reserved.</p>
    </div>
  </div>
</footer>
